<template>
  <div class="container">
    <div class="title"><h1>Contact Info</h1></div>
    <div class="screen">
      <!-- <div class="contentpair"> -->
      <!-- <div class="contactnote">
        <p>
          I would love to hear about new opportunities.
          <br />
          <br />Please feel free to reach out.
        </p>
      </div> -->
      <div class="contactinfo">
        <a href="mailto:matthewjohnfranklin@gmail.com" target="_blank">
          <svg
            id="emailicon"
            class="contacticon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="2 2 20 20"
          >
            <path
              d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
            />
          </svg>
          MatthewJohnFranklin@gmail.com
        </a>
        <br />
        <br />
        <a href="https://www.linkedin.com/in/matt-franklin/" target="_blank">
          <svg
            id="libug"
            class="contacticon"
            data-name="libug"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
          >
            <path
              d="M63.9868.0358C82.1578.0359,100.3291.09,118.5,0a9.3622,9.3622,0,0,1,9.4071,7.7007,9.5348,9.5348,0,0,1,.1148,1.4242q.0078,54.8573.0026,109.7145a9.11,9.11,0,0,1-8.6892,9.0744c-.3191.0139-.6389.0131-.9583.0131q-54.3931.0007-108.7863-.0012c-4.5515,0-7.9932-2.4423-9.1888-6.5666a9.8485,9.8485,0,0,1-.3853-2.7015Q-.012,63.98.0014,9.3026A9.0646,9.0646,0,0,1,9.1146.0493C13.5069-.0047,17.9.0359,22.2934.0358Q43.14.0353,63.9868.0358Zm4.2858,55.7834c0-2.1945-.0529-4.3907.0221-6.5826.038-1.1129-.3415-1.4245-1.4352-1.4138-5.1906.051-10.382.0218-15.5731.0233-1.59.0005-1.5959.0037-1.596,1.5653q-.0021,29.1621-.026,58.3241c-.0023,1.2256.3776,1.5716,1.5695,1.56,5.39-.0517,10.7813-.02,16.1721-.024,1.6009-.0011,1.6046-.0091,1.6048-1.5725.0012-9.7805-.0262-19.5612.0226-29.3415a35.4539,35.4539,0,0,1,.4972-6.06c.7422-4.1361,2.6482-7.4763,7.0746-8.5774a16.4713,16.4713,0,0,1,4.1429-.3771c4.561.0565,7.4166,2.1934,8.4165,6.6244a36.0174,36.0174,0,0,1,.7964,7.571c.0867,10.0593.0529,20.12.0139,30.18-.0047,1.2036.3667,1.59,1.5751,1.5781q8.0853-.08,16.1719-.0018c1.1636.01,1.58-.282,1.5746-1.5349-.0483-11.6566.0894-23.3153-.0953-34.9692a56.222,56.222,0,0,0-1.4525-11.5735c-1.5554-6.791-5.5063-11.7508-12.4518-13.6982a48.3227,48.3227,0,0,0-7.4063-1.1252,19.7257,19.7257,0,0,0-11.8743,2.3542A22.6037,22.6037,0,0,0,68.2726,55.8192ZM18.7586,78.528c0,9.7772.0125,19.5545-.019,29.3316-.0032.9932.207,1.4388,1.3049,1.4309q8.3823-.0606,16.7652-.0035c1.0064.0057,1.2871-.38,1.2861-1.3452Q38.0642,78.55,38.1,49.1589c.0016-1.08-.37-1.3411-1.39-1.3333-5.5084.0424-11.0176.054-16.5256-.0069-1.1869-.0131-1.4545.3746-1.45,1.4975C18.7757,59.0533,18.7586,68.7907,18.7586,78.528Zm9.6422-38.8864A11.11,11.11,0,1,0,17.312,28.5858,11.0462,11.0462,0,0,0,28.4008,39.6416Z"
            />
          </svg>
          LinkedIn
        </a>
        <!-- <br /> -->
        <!-- <br /> -->
        <!-- <a href="tel:+13346256640" target="_blank">
          <svg
            id="phoneicon"
            class="contacticon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="2 2 22 22"
          >
            <path
              d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
            />
          </svg>
          +1-334-625-6640
        </a> -->
      </div>
    </div>
    <footer class="copyright">© 2022 Matt Franklin</footer>
  </div>
</template>

<script>
export default {
  name: "Screen",
};
</script>

<style scoped>
.screen {
  width: 100%;
  /* min-height: 90%; */
}
.container {
  width: 100%;
  /* min-height: 50%; */
  scroll-snap-align: end;
  position: relative;
  background-color: black;
}
.title {
  height: 10%;
  margin: 0px;
  margin-block-start: 0px;
  margin-block-end: 2vh;
}
.contactnote > p {
  font-size: 3vh;
  text-align: center;
  color: white;
  margin: auto;

  margin-block-start: 0vh;
  margin-block-end: 0vh;
}
.contactnote {
  margin-bottom: 5vh;
}
.contactinfo > a {
  /* display: block; */
  color: white;
  text-decoration: none;

  font-size: 3vh;
  font-weight: 400;
  margin: 2vmin;
  /* margin-left: 0px; */
  /* paddint-margin-bottom */
  /* padding-top: 10px; */
  /* line-height: 40px; */
  /* margin: 20px; */
}
.contacticon {
  height: 2.5vh;
  fill: white;
  margin-right: 0.1vh;
}
footer {
  color: var(--light-blue);
  /* height: 5vh; */
  margin-top: 5vh;
  padding-bottom: 2.5vh;
  font-size: 1.75vh;
}
</style>
